import {notification} from "antd"

export const showNotification = (type: "error" | "success", message: string) => {
  notification[type]({
    message,
    placement: 'bottomRight',
    // description: 'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
  })
}

export const showResponseMessage = (data: {error: boolean, message: string}) => {
  showNotification(data.error ? 'error' : 'success', data.message)
}
